import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import GenericButton from '../../../../components/GenericButton'
import { type HandleBackFn, type HandleNextFn } from '../SurveyFeatureStepper/types'
import { useStepper } from '../SurveyFeatureStepper/useStepper'
import { ButtonSize, ButtonType } from '../../../../components/GenericButton/styles'
import ProgressBar from '../ProgressBar'
import { getIsLoading } from '../../../../store/slices/studentSurveyListSlice/selectors'

interface RenderControlsProps {
  handleBack: HandleBackFn
  handleNext: HandleNextFn
  sections: any
}

export const StepNavigation: React.FC<RenderControlsProps> = (props: RenderControlsProps) => {
  const { handleBack, handleNext, sections } = props
  const isLoading = getIsLoading()

  const theme = useTheme()

  const { step } = useStepper()

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      p={'10px 18px'}
      mt={theme.spacing(6)}
      position={'fixed'}
      width={'100%'}
      bottom={0}
      right={0}
      bgcolor={'white'}
      style={{ boxShadow: '0px -4px 4px -3px rgba(0,0,0,0.3)' }}
    >
      <GenericButton buttonSize={ButtonSize.Small} label='Back' buttonType={ButtonType.Primary} onClick={handleBack} disabled={step === 0} />

      <ProgressBar />
      <Box display={'flex'} gap={3} alignItems={'center'}>
        <Typography fontSize='18px'><b>{step + 1} of {sections.length}</b> sections </Typography>
        <GenericButton buttonSize={ButtonSize.Small} label={sections.length - 1 === step ? 'Submit' : 'Next'} buttonType={ButtonType.Primary} onClick={handleNext} loading={isLoading} />
      </Box>
    </Box>
  )
}
